import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { BusinessDtoKeysEnum } from '@zaoblako/shared/modules/business/enum/business-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import type { NomenclatureItemFindInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-item-find.dto';

import * as yup from 'yup';

/** Deal order create or update request body */
export interface DealOrderFormInterface {
  /** Unique identifier. Cannot be changed, need to update already exists orders from orders' list */
  id?: number;
  /** Nomenclature item */
  nomenclatureItem: NomenclatureItemFindInterface;
  /** Price of nomenclature. Equals {@link NomenclatureFindInterface.price} by default, but may differ from it. */
  price?: number;
  /** Number of nomenclature items. */
  count: number;
  /** Total sum of nomenclature. */
  amount?: number;
}

/** Deal order create or update request body - DTO schema */
export const DealOrderFormDto = SerdeDtoClass.create<DealOrderFormInterface>(BusinessDtoKeysEnum.DEAL_ORDER_FORM_DTO, {
  id: {
    optional: true,
    label: 'Номер',
    serializer: yup
      .number()
      .positive(DtoMessageEnum.NOT_POSITIVE)
      .integer(DtoMessageEnum.NOT_INTEGER),
  },
  nomenclatureItem: {
    label: 'Номенклатура',
    serializer: yup.object({
      id: yup
        .number()
        .positive(DtoMessageEnum.NOT_POSITIVE)
        .integer(DtoMessageEnum.NOT_INTEGER),
    }) as yup.Schema<any>,
  },
  price: {
    optional: true,
    label: 'Цена',
    serializer: yup
      .number()
      .positive(DtoMessageEnum.NOT_POSITIVE),
  },
  count: {
    label: 'Количество',
    serializer: yup
      .number()
      .positive(DtoMessageEnum.NOT_POSITIVE)
      .integer(DtoMessageEnum.NOT_INTEGER),
  },
  amount: {
    optional: true,
    label: 'Сумма',
    serializer: yup
      .number()
      .positive(DtoMessageEnum.NOT_POSITIVE),
  },
});
